export function clamp01(value: number): number {
    if (!Number.isFinite(value)) return 0
    return Math.max(0, Math.min(1, value))
}

export function normalize(value: number, min: number, max: number, invert = false): number {
    if (!Number.isFinite(value) || !Number.isFinite(min) || !Number.isFinite(max) || min === max) {
        return 0.5
    }
    const ratio = (value - min) / (max - min)
    const clamped = Math.max(0, Math.min(1, ratio))
    return invert ? 1 - clamped : clamped
}

